<section class="t-pad-bottom">
  <users-filters
    id="usersSearch"
    class="l-block t-row--med"
    (onSearch)="getUsersBySearch($event)"
    (onCreateUser)="onCreateUserClicked()"
  ></users-filters>

  <loader *ngIf="usersLoading"></loader>

  <div
    *ngIf="displayUsers && !displayUsers.length && !usersLoading"
    role="alert"
    class="c-alert t-alert-info"
  >
    {{ "translate.alert.noResults" | translate }}
  </div>

  <users-list
    [users]="displayUsers"
    [totalRecords]="userSearchMetaData.totalRecords"
    [numberOfRows]="numberOfRows"
    (requestUpdate)="loadDataOnPagination($event)"
    (onEditUser)="editUser($event)"
  ></users-list>
</section>

